import { useEffect, useState } from "react";
import axios from "../../../../Axios";
import styles from "./FileUploadResultScreen.module.css";
import { Urls } from "../../../../Urls";
import { exportRPTResultsToExcel } from "../../../../Shared_utilities/fileDownloadUtils";

export default function FileUploadResultScreen({ lanes, onBack }) {
  const [results, setResults] = useState([]);
  const [completed, setCompleted] = useState(false);

  useEffect(() => {
    async function fetchPredictions() {
      try {
        const payload = lanes.map((lane) => ({
          origin: lane.origin_details,
          destination: lane.destination_details,
          truck: {
            truck_type: lane.truck_details.raw_truck_name,
            no_of_wheels: lane.truck_details.user_dimensions.no_of_wheels,
            capacity_mt: parseFloat(
              lane.truck_details.user_dimensions.capacity_mt
            ),
            length_ft: parseFloat(lane.truck_details.user_dimensions.length_ft),
            axle_type: lane.truck_details.user_dimensions.axle_type,
            body_type: lane.truck_details.user_dimensions.body_type,
          },
          date: new Date(lane.date).toISOString().split("T")[0],
        }));

        const bulkPredictUrl = `${Urls.rpt_base_url}/bulk_predict`;

        const { data } = await axios.post(bulkPredictUrl, payload);

        setResults(data);
      } catch (err) {
        console.error("Bulk prediction failed", err);
      } finally {
        setCompleted(true);
      }
    }

    fetchPredictions();
  }, [lanes]);

  return (
    <div className={styles.resultContainer}>
      <div className="d-flex align-items-center justify-content-between">
        <div className="d-flex flex-column">
          <h3 className={styles.title}>Forecasted Rates for Uploaded Lanes</h3>
          <p className={styles.subtitle}>
            These rates are based on inferred features and market intelligence.
          </p>
        </div>
      </div>

      <div className={styles.tableContainer}>
        <table className={styles.table}>
          <colgroup>
            <col className={styles.colSrNo} />
            <col className={styles.colOrigin} />
            <col className={styles.colDestination} />
            <col className={styles.colTruck} />
            <col className={styles.colDate} />
            <col className={styles.colPrice} />
          </colgroup>
          <thead>
            <tr>
              <th>#</th>
              <th>Origin</th>
              <th>Destination</th>
              <th>Truck</th>
              <th>Date</th>
              <th>Forecasted Rate</th>
            </tr>
          </thead>
          <tbody>
            {lanes.map((lane, index) => {
              const res = results[index];
              return (
                <tr key={index}>
                  <td>{index + 1}</td>
                  <td>{lane?.origin_details?.location_name}</td>
                  <td>{lane?.destination_details?.location_name}</td>
                  <td>{lane.truck_type}</td>
                  <td>{new Date(lane.date).toLocaleDateString("en-IN")}</td>
                  <td className="font-weight-bold">
                    {res ? (
                      res.error ? (
                        <span className={styles.error}>Error</span>
                      ) : (
                        `₹ ${res.predicted_base_price.toFixed(2)}`
                      )
                    ) : (
                      <span className={styles.loading}>Loading...</span>
                    )}
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>

      <details
        className={`${styles.disclaimerInline} ${styles.disclaimerDetails}`}
      >
        <summary>Important — indicative rates only (read more)</summary>
        <div>
          <div className="pb-1">
            These are <strong>indicative rates</strong> estimated by Lorri AI
            using historical freight data, fuel trends, and lane analytics.
          </div>
          <ul className={styles.disclaimerList}>
            <li>
              Assumes current average diesel price; real-time conditions may
              vary.
            </li>
            <li>
              Final rates depend on availability, seasonality, and negotiation.
            </li>
            <li>Use for planning/benchmarking, not as a binding quote.</li>
          </ul>
        </div>
      </details>

      <div className={styles.actions}>
        <div className={styles.actionButtonContainer}>
          <button className={styles.backBtn} onClick={onBack}>
            Back
          </button>
          <button
            className={`${styles.downloadBtn} mr-2`}
            onClick={() => {
              exportRPTResultsToExcel(lanes, results);
            }}
          >
            Download Excel
          </button>
        </div>
        {completed && <span className={styles.done}>All lanes processed.</span>}
      </div>
    </div>
  );
}
